module.exports = __webpack_public_path__ + "static/media/113n.5ec8df1e.svg";